import { apiCartTokenTrack } from '../../../analytics/tracker/events/bugTrack';
import { TRACK_ORDER_TYPE } from '../../../axios/appiendPoints';
import { axiosInstance } from '../../../axios/axios';
import { getUserToken } from '../../../webStorage/localStorage';

export const updateCartDetails = async (cart_token, restaurant_id, table_id, order_type) => {
  try {
    if (!order_type) return;
    let params = new URLSearchParams();
    params.append('cart_token', cart_token);
    apiCartTokenTrack({
      fileName: 'trackOrderType.js',
      functionName: 'updateCartDetails',
      cartToken: cart_token || cart_token + '',
    });
    params.append('restaurant_id', restaurant_id);
    params.append('table_id', table_id);
    params.append('order_type', order_type);
    params.append('token', getUserToken());
    axiosInstance.post(TRACK_ORDER_TYPE, params);
  } catch (error) {
    console.log(error);
  }
};
